export class State {
  public static inProgress: boolean = false;
  public static type: string = '';
  public static points: number[][] = [];
  public static fightR: boolean = false;
}
